import { render, staticRenderFns } from "./ArticleParticulars.vue?vue&type=template&id=1f0ded78&scoped=true"
import script from "./ArticleParticulars.vue?vue&type=script&lang=js"
export * from "./ArticleParticulars.vue?vue&type=script&lang=js"
import style0 from "./ArticleParticulars.vue?vue&type=style&index=0&id=1f0ded78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ded78",
  null
  
)

export default component.exports